import { useEffect, useRef } from 'react';
import { useIsChromeHidden } from '@components/MainStage/uiChrome.store';

type Props = {
  expand: () => void;
  collapse: () => void;
};

const useCollapseWithChrome = ({ expand, collapse }: Props) => {
  const isChromeHidden = useIsChromeHidden();

  const actionsRef = useRef({ expand, collapse });
  actionsRef.current = { expand, collapse };

  const isCollapsedByChrome = useRef(false);

  useEffect(() => {
    if (isChromeHidden) {
      isCollapsedByChrome.current = true;
      actionsRef.current.collapse();
      return;
    }

    if (!isCollapsedByChrome.current) return;

    isCollapsedByChrome.current = false;
    actionsRef.current.expand();
  }, [isChromeHidden]);
};

export default useCollapseWithChrome;
